<template>
    <div class="d-md-flex align-items-center justify-content-between mb-2 mt-2">
        <div>
            <h4 class="main-title mb-0"><router-link to="/muddemal" type="button"><i
                        class="ri-arrow-left-line menu_icon text-dark fs-18 lh-1 me-2"></i></router-link>View Muddemal
            </h4>
        </div>
        <div class="d-flex gap-2 mt-3 mt-md-0">
            <router-link :to="'/muddemal/' + form?.muddemal_id + '/edit'" type="button" class="btn btn-success"><i
                    class="ri-edit-line fs-18 lh-1 me-1"></i>Edit Muddemal</router-link>
            <router-link to="/muddemal" type="button" class="btn btn-primary"><i
                    class="ri-menu-line fs-18 lh-1 me-1"></i>Muddemals</router-link>
        </div>
    </div>
    <div class="row g-3">
        <div class="col-md-12">
            <div class="card card-one mb-4">
                <!-- <div class="card-header">
                    <h6 class="card-title">PF Details</h6>
                </div> -->
                <div class="card-header d-flex justify-content-between">
                    <h5 class="text-primary">PF Details</h5>
                    <button class="btn btn-sm btn-success" @click="pdfExportPF()">Export PF (pdf)</button>
                </div>
                <div class="card-body">
                    <div class="mb-3">
                        <div class="row g-2 align-items-center">
                            <div class="col-md-3">
                                <h6>PF Number</h6>
                                <p>{{ form.pf_number }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>PF Date</h6>
                                <p>{{ form.pf_date }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>PF Year</h6>
                                <p>{{ form.year }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Crime No & U/s</h6>
                                <p>{{ form.crime_no_sec }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Investigation Officer</h6>
                                <p>{{ form.investigation_officer }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Siezed From Whom</h6>
                                <p>{{ form.siezed_from_whom }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Siezed From Place</h6>
                                <p>{{ form.siezed_from_place }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>CC No/ SC No</h6>
                                <p>{{ form.cc_sc_no }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Present Stage of the Case</h6>
                                <p>{{ form.case_stage?.case_stage }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>PR No.</h6>
                                <p>{{ form.pr_no }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>PR Date</h6>
                                <p>{{ form.pr_date }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Holding Officer</h6>
                                <p>{{ form.holding_officer }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Police Station</h6>
                                <p>{{ form.police_Station?.police_station }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Division</h6>
                                <p>{{ form.police_Station?.division?.division }}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>Sub Division</h6>
                                <p>{{ form.police_Station?.sub_division?.sub_division }}</p>
                            </div>
                        </div>
                    </div>
                    <h5 class="mb-2"> Siezed Property Details &amp; Movement</h5>
                    <div v-for="item in propertyDetails" :key="item.property_id" class="property-section mb-4">
                        <div class="d-flex align-items-center gap-2 mb-2">
                            <a href="javascript:void(0)" @click="openQrCodeModal(item.qr_code)">
                                <img :src="item.qr_code" height="40" alt="QR" />
                            </a>
                            <span class="text-muted">Property ID: {{ item.property_id }}</span>
                        </div>
                        <PropertyMovementCard
                            :property="item"
                            :location-breakdown="item.location_breakdown || []"
                            :movements="item.movements || []"
                            :fsl-batches="item.fsl_batches || []"
                            :total-quantity="item.total_quantity || 0"
                            :show-movement-action-buttons="false"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <SendToFSLDialog
        ref="sendFSLDialog"
        :property="selectedProperty"
        :available-quantity="availablePSQuantity"
        @refresh="refreshPropertyDetails"
    />
    <ReceiveFromFSLDialog
        ref="receiveFSLDialog"
        :property="selectedProperty"
        :fsl-batches="selectedProperty?.fsl_batches || []"
        :current-p-s-quantity="availablePSQuantity"
        :current-f-s-l-quantity="availableFSLQuantity"
        @refresh="refreshPropertyDetails"
    />
    <SendToCourtDialog
        ref="sendCourtDialog"
        :property="selectedProperty"
        :available-quantity="availablePSQuantity"
        @refresh="refreshPropertyDetails"
    />
    <DestroyPropertyDialog
        ref="destroyDialog"
        :property="selectedProperty"
        :available-quantity="availablePSQuantity"
        @refresh="refreshPropertyDetails"
    />
    <UpdateLocationDialog
        ref="updateLocationDialog"
        :property="selectedProperty"
        :location-breakdown="selectedProperty?.location_breakdown || []"
        @refresh="refreshPropertyDetails"
    />
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
        <div class="modal-content" @click.stop>
            <h3 style="margin-right: auto;">QR Code</h3>
            <span class="close-btn" @click="closeModal">&times;</span>
            <!-- <img :src="selectedQrCode" alt="QR Code" style="max-width: 100%; height: auto;"> -->
            <div class="modal-body mb-4">
                <img :src="selectedQrCode" alt="QR Code" style="max-width: 100%; height: auto;">
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary me-2" @click="closeModal">Close</button>
                <button type="button" class="btn btn-success" @click="downloadQrCode(selectedQrCode)">Download</button>
            </div>
        </div>
    </div>
</template>
<script>
import html2pdf from 'html2pdf.js';
import moment from 'moment';
import PropertyMovementCard from '@/components/PropertyMovementCard.vue';
import SendToFSLDialog from '@/components/SendToFSLDialog.vue';
import ReceiveFromFSLDialog from '@/components/ReceiveFromFSLDialog.vue';
import SendToCourtDialog from '@/components/SendToCourtDialog.vue';
import DestroyPropertyDialog from '@/components/DestroyPropertyDialog.vue';
import UpdateLocationDialog from '@/components/UpdateLocationDialog.vue';

export default {
    name: "MuddemalView",
    components: {
        PropertyMovementCard,
        SendToFSLDialog,
        ReceiveFromFSLDialog,
        SendToCourtDialog,
        DestroyPropertyDialog,
        UpdateLocationDialog
    },
    data() {
        return {
            form: [],
            properties: [],
            propertyDetails: [],
            selectedProperty: {},
            showModal: false,
            selectedQrCode: null,
            sample_text: 'Testing',
        };
    },
    computed: {
        availablePSQuantity() {
            const psLoc = this.selectedProperty?.location_breakdown?.find(l => l.type === 'ps');
            return psLoc ? psLoc.quantity : 0;
        },
        availableFSLQuantity() {
            const fslLoc = this.selectedProperty?.location_breakdown?.find(l => l.type === 'fsl');
            return fslLoc ? fslLoc.quantity : 0;
        }
    },
    beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            try {
                const uri = { uri: "getMuddemal", data: { muddemal_id: to.params.muddemal_id } };
                const response = await vm.$store.dispatch("post", uri);
                vm.form = response.data.data;
                vm.properties = response.data.data.properties || [];
                vm.propertyDetails = (response.data.data.properties || []).map(p => ({ ...p }));
                for (const p of vm.properties || []) {
                    await vm.loadPropertyMovements(p.property_id);
                }
            } catch (error) {
                vm.errors = error.response?.data?.errors;
                vm.$store.dispatch("error", error.response?.data?.message);
            }
        });
    },
    methods: {
        async getMuddemal() {
            const uri = { uri: "getMuddemal", data: { muddemal_id: this.$route.params.muddemal_id } };
            const response = await this.$store.dispatch("post", uri);
            this.form = response.data.data;
            this.properties = response.data.data.properties || [];
            this.propertyDetails = (this.properties).map(p => ({ ...p }));
        },
        async refreshPropertyDetails() {
            await this.getMuddemal();
            for (const property of this.properties) {
                await this.loadPropertyMovements(property.property_id);
            }
        },
        async loadPropertyMovements(propertyId) {
            try {
                const response = await this.$store.dispatch('post', {
                    uri: 'getPropertyWithMovements',
                    data: { property_id: propertyId }
                });
                const data = response.data;
                const index = this.propertyDetails.findIndex(p => p.property_id === propertyId);
                if (index !== -1) {
                    this.propertyDetails[index] = {
                        ...this.propertyDetails[index],
                        location_breakdown: data.location_breakdown,
                        movements: data.movements,
                        fsl_batches: data.fsl_batches,
                        total_quantity: data.total_quantity
                    };
                } else {
                    this.propertyDetails.push({
                        ...data.property,
                        location_breakdown: data.location_breakdown,
                        movements: data.movements,
                        fsl_batches: data.fsl_batches,
                        total_quantity: data.total_quantity
                    });
                }
            } catch (error) {
                console.error('Error loading property movements:', error);
            }
        },
        openSendFSL(item) {
            this.selectedProperty = item;
            this.$refs.sendFSLDialog?.open();
        },
        openReceiveFSL(item) {
            this.selectedProperty = item;
            this.$refs.receiveFSLDialog?.open();
        },
        openSendCourt(item) {
            this.selectedProperty = item;
            this.$refs.sendCourtDialog?.open();
        },
        openDestroy(item) {
            this.selectedProperty = item;
            this.$refs.destroyDialog?.open();
        },
        openUpdateLocation(item) {
            this.selectedProperty = item;
            this.$refs.updateLocationDialog?.open();
        },
        openQrCodeModal(qrCode) {
            this.selectedQrCode = qrCode;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        downloadQrCode(selectedQrCode) {
            const link = document.createElement('a');
            link.href = selectedQrCode;
            link.download = 'qr_code_image.jpg';
            link.click();
        },

        pdfExportPF() {
            const pdfContent = `
                <!DOCTYPE html>
                <html lang="en">
                <head>
                    <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Kannada&display=swap" rel="stylesheet">
                    <style>
                        body {
                            font-family: 'Noto Sans Kannada', sans-serif;
                            margin: 10px;
                        }
                        table, th, td {
                            border: 1px solid black;
                            border-collapse: collapse;
                            font-size: 100%;
                        }
                        .page-break {
                            page-break-before: always;
                        }
                        tr {
                            page-break-inside: avoid;
                        }
                    </style>
                </head>
                <body>
                    <div class="row">
                        <div class='col-12 d-flex justify-content-around'>
                            <h3>ಕರ್ನಾಟಕ ರಾಜ್ಯ ಪೊಲೀಸು</h3>
                        </div>
                        <div class='col-4'>
                            <h5>ನಮೂನೆ ಸಂ. 131</h5>
                        </div>
                        <div class='col-8 text-end'>
                            <h5>(ಆದೇಶ ಸಂ 1286, 1305, ಮತ್ತು 1326 (2))</h5>
                        </div>
                        <br><br>
                        <div class='col-12 text-center' style='text-underline-offset: 5px'>
                            <h5>ಮ್ಯಾಜಿಸ್ಟ್ರೇಟ್ ಅವರಿಗೆ ಕಳುಹಿಸಿದ ಸ್ವತ್ತಿನ ಪಟ್ಟಿ.</h5>
                        </div>
                        <div class='col-12'>
                            <table class='table'>
                                <tbody>
                                    <tr>
                                        <td colspan='2'>
                                            <h5>ಪೊಲೀಸ್ ಠಾಣೆ:
                                                <span style="font-family: 'Times New Roman';">${this.form.police_Station.police_station}</span>
                                            </h5>
                                        </td>
                                        <td>
                                            
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width='5%'>1</td>
                                        <td width='50%'>ಸ್ವತ್ತು ಪಟ್ಟಿಯ ಸಂಖ್ಯೆ ಮತ್ತು ದಿನಾಂಕ</td>
                                        <td><span style="font-family: 'Times New Roman';">${this.form.pf_number}</span></td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>ಪೊಲೀಸ್ ಕಡತದಲ್ಲಿ ಪ್ರಕರಣದ ಸಂಖ್ಯೆ</td>
                                        <td><span style="font-family: 'Times New Roman';">${this.form.crime_no_sec}, ${this.form.section_of_law}</span></td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>ಸ್ವಾದೀನ ಪಡಿಸಕೊಳ್ಳುವ ಪೊಲೀಸ್ ಅಧಿಕಾರಿಯ ದರ್ಜೆ ಮತ್ತು ಹೆಸರು</td>
                                        <td><span style="font-family: 'Times New Roman';">${this.form.investigation_officer}</span></td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>ಸ್ವಾದೀನ ಪಡಿಸಕೊಳ್ಳುಲಾದ ಸ್ವತ್ತಿನ ವಿವರಗಳು ಮತ್ತು ಮೌಲ್ಯ.</td>
                                        <td>
                                            <ol style='margin-left:-15px;'>
                                                ${this.form.properties.map(property => `<li style="font-family: 'Times New Roman';">${property.property_description}</li>`).join('')}
                                            </ol>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td rowspan="2">
                                        ಇವುಗಳನ್ನು ಯಾವಾಗ ಯಾರಿಂದ ಸ್ವಾದೀನ ಪಡಿಸಿಕೊಂಡಿದ್ದು ಮತ್ತು ಎಲ್ಲಿ ದೊರೆತಿದ್ದು,<br>
                                        ಯಾರಿಂದ ಯಾವಾಗ ಮತ್ತು ಎಲ್ಲಿ ಅವುಗಳನ್ನು ಕದಿಯಲಾಯಿತು ಮತ್ತು ಸಂಶಯಾಸ್ಪದ
                                        </td>
                                        <td rowspan="2">
                                            <span style="font-family: 'Times New Roman';">
                                                PF Date: ${moment(this.form.pf_date).format('DD-MM-YYYY')},<br>
                                                Seized From Whom: ${this.form.siezed_from_whom},<br>
                                                Seized From Place: ${this.form.siezed_from_place}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>6</td>
                                    </tr>
                                    <tr>
                                        <td>7</td>
                                        <td>ಸಾಕ್ಷಿಗಳ ಸಹಿ:<br>
                                            i)<br><br>
                                            ii)<br><br>
                                            iii)<br><br>
                                            ಪಂಚನಾಮೆ ಲಗತ್ತಿಸಿರುತ್ತದೆ
                                            <br><br><br><br>
                                        </td>
                                        <td class='text-center'>
                                            <br><br><br><br><br><br><br><br>
                                            ಪೊಲೀಸ್ ಅಧಿಕಾರಿಯ ಸಹಿ
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>8</td>
                                        <td>ಮ್ಯಾಜಿಸ್ಟ್ರೇಟ್ ಅವರಿಗೆ ವರದಿಯನ್ನು ಸಲ್ಲಿಸಿದ ದಿನಾಂಕ</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>9</td>
                                        <td>ಮ್ಯಾಜಿಸ್ಟ್ರೇಟ್ ಅವರ ಆದೇಶಗಳ</td>
                                        <td></td>
                                    </tr>                    
                                    <tr>
                                        <td>10</td>
                                        <td>ಸ್ವತ್ತನ್ನು ಸ್ವೀಕರಿಸಿದ್ದಕ್ಕೆ ಸಂಬಂದಿಸಿದಂತೆ ನ್ಯಾಯಾಲಯ ಗುಮಾಸ್ತನ ಹಿಂಬರಹ</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>11</td>
                                        <td>ಸ್ವತ್ತಿನ ಅಂತಿಮ ವಿಲೆ: </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class='col-12 text-end'>
                            <br><br>
                            ಪೊಲೀಸ್ ಅಧಿಕಾರಿಯ ಸಹಿ
                        </div>
                    </div>
                </body>
                </html>
            `;

            this.$nextTick(() => {
                const options = {
                    margin: [1.5, 1.5, 1.5, 1.5],
                    filename: 'PF_Form.pdf',
                    // image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: { scale: 4, letterRendering: true },
                    jsPDF: { unit: 'cm', format: 'A4', orientation: 'portrait' },
                    pagebreak: { mode: 'css', before: '.page-break', avoid: ['tr'] }
                };
                html2pdf().from(pdfContent).set(options).save();
            });

        }
    },
};
</script>
<style scoped>
p {
    color: #6e7985;
}

.menu_icon {
    font-size: 20px;
    opacity: 0.85;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 500px;
    text-align: center;
    position: relative;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
    z-index: 1001;
    background: transparent;
    border: none;
}

.close-btn:hover {
    color: red;
}
</style>